
import DynamicFormField from '@/components/release/form/DynamicFormField'
export default {
    name: 'SkuDialog',
    components: {
        DynamicFormField
    },
    props: {
        feeDataList: {
            type: Array,
            default: () => []
        },
        releaseData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            formData: {
                enable: true
            },
            rules: {
            },
            editIndex: 0,
            formFields: [],
            visible: false,
            action: 'addSku'
        }
    },
    computed: {
        disabled() {
            return Object.values(this.formData).some(item => !item)
        }
    },
    methods: {
        open(index, fields, values = null) {
            this.editIndex = index
            this.formFields = fields
            this.action = index === -1? 'editSpu' : values ? 'editSku' : 'addSku'
            this.initSkus(values)
            this.visible = true;
        },
        initSkus(values) {
            const skuFields = this.formFields.reduce((acc, field) => {
                acc[field.mappingField] = values?.[field.mappingField] || ''
                return acc
            }, {})
            // 编辑的时候会有id
            if (values?.id) {
                skuFields.id = values.id
            }
            this.formData = { ...skuFields };
        },
        handleConfirm() {
            this.$refs.skuForm.validate((valid) => {
                if (valid) {
                    this.$emit('confirm', this.formData, this.action, this.editIndex)
                    this.handleClose()
                } else {
                    return false
                }
            })
        },
        handleClose() {
            this.visible = false
        }
    }
}
